import { inject, Injectable } from '@angular/core';
import { CookieService } from 'ng2-cookies';
import { environment } from 'environments/environment';
import { cookieExpiration } from '../utils/expires';
import { ECN_VERSION_INTRO_COOKIE } from '@shared-types/common';

@Injectable({ providedIn: 'root' })
export class VersionIntroService {
  private readonly cookieService = inject(CookieService);


  shouldShowVersionIntro(currentVersion: string): boolean {
    if (!this.cookieService.check(ECN_VERSION_INTRO_COOKIE)) {
      return true;
    }
    const lastVersion = this.cookieService.get(ECN_VERSION_INTRO_COOKIE).split('.');
    if (!lastVersion || lastVersion.length < 3) {
      return true;
    }
    const currentParts = currentVersion.split('.');
    if (lastVersion[0] !== currentParts[0] || lastVersion[1] !== currentParts[1]) {
      return true;
    }
    return false;
  }

  setVersionIntroCookie(): void {
    this.cookieService.set(
      ECN_VERSION_INTRO_COOKIE,
      environment.version,
      cookieExpiration.expires(),
      '/'
    );
  }
}
